module.exports = __webpack_public_path__ + "static/media/view3.3b6069ce.jpg";